export default __webpack_public_path__ + "static/media/edtech.54116084.png";